export default __webpack_public_path__ + "static/media/dentalcare.506ea6cb.jpg";